import React, {Component} from 'react';
import Header from "../../../components/Header/header";
import Layout from "../../../components/Layout/layout";
import wine from "../../../assets/product/wine@2x.png";
// import './demo.scss';

class Art extends Component {
    constructor(props) {
        super(props);
        this.state = {};

    }

    componentWillMount() {

    }

    componentDidMount() {

    }

    componentWillUnmount() {

    }

    // shouldComponentUpdate() {
    //
    // }

    render() {
        const {} = this.state;

        return (
            <Layout location={this.props.location}>
                <img className="content-img" src={wine} alt=""/>
            </Layout>
        );
    }
}

export default Art;



// WEBPACK FOOTER //
// ./src/pages/Index/index.js
